import NotificationService from '../../services/NotificationService'
import router from '../../router'

const state = () => ({
    loadingNotifications: false,
    notification: null,
    notifications: [],
    notifications_user: [],
    total: 0,
    pages: 0,
    page: 1,
    total_user: 0,
    pages_user: 0,
    page_user: 1,
    show_modal_new_notification: false
})
  
const mutations = {
    SET_NOTIFICATION: (state, payload) => {
        state.notification = payload
    },
    SET_NOTIFICATIONS: (state, payload) => {
        if(payload.pageNumber == 1) {
            state.notifications = payload.itens
        }else{
            state.notifications = [...state.notifications, ...payload.itens]
        }
        state.page =  payload.pageNumber
        state.pages =  payload.pages
        state.total =  payload.total
    },
    SET_NOTIFICATIONS_USER: (state, payload) => {
        if(payload.pageNumber == 1) {
            state.notifications_user = payload.itens
        }else{
            state.notifications_user = [...state.notifications_user, ...payload.itens]
        }
        state.page_user =  payload.pageNumber
        state.pages_user =  payload.pages
        state.total_user =  payload.total
    },
    SET_LOADING_NOTIFICATIONS: (state, payload) => {
        state.loadingNotification = payload
    },
    SET_SHOW_MODAL_NOTIFICATION: (state, payload) => {
        state.show_modal_new_notification = payload
    },
}

const actions = {
    async fetchNotification({commit}, id){
        try{
            commit('SET_LOADING_NOTIFICATIONS', true)
            const response = await NotificationService.getOne(id);
            const dataNotification = response.data.item
            if(dataNotification){
                dataNotification.createdAt = await formatarData(dataNotification.createdAt);
                dataNotification.updatedAt = await formatarData(dataNotification.updatedAt);
            }
            commit('SET_NOTIFICATION', dataNotification)
            commit('SET_LOADING_NOTIFICATIONS', false)
        } catch (error) {
            commit('SET_LOADING_NOTIFICATIONS', false);
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async fetchNotifications({commit}, { keyword = '', pageNumber = 1, sortBy = 'mais recentes' }){
        try{
            commit('SET_LOADING_NOTIFICATIONS', true)
            const response = await NotificationService.get(keyword, pageNumber, sortBy);
            commit('SET_NOTIFICATIONS', response.data)
            commit('SET_LOADING_NOTIFICATIONS', false)
        } catch (error) {
            commit('SET_LOADING_NOTIFICATIONS', false);
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async fetchUsersNotifications({commit}, params = {}){
        try{
            commit('SET_LOADING_NOTIFICATIONS', true)
            const { UserId = null, NotificationId = null, keyword = '', pageNumber = 1, pageSize = 12, order = { name: 'ID', column: 'ID', sort: 'ASC' } } = params;
            const response = await NotificationService.getUsersNotifications(UserId, NotificationId, keyword, pageNumber, pageSize, order);
            commit('SET_NOTIFICATIONS_USER', response.data)
            commit('SET_LOADING_NOTIFICATIONS', false)
        } catch (error) {
            commit('SET_LOADING_NOTIFICATIONS', false);
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async fetchTotaisUsersNotifications({commit}, NotificationId){
        try{
            commit('SET_LOADING_NOTIFICATIONS', true)
            const response = await NotificationService.getTotaisUsersNotifications(NotificationId);
            commit('SET_LOADING_NOTIFICATIONS', false)
            return response.data
        } catch (error) {
            commit('SET_LOADING_NOTIFICATIONS', false);
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async createNotification({commit}, data){
        try{
            commit('SET_LOADING_NOTIFICATIONS', true)
            const dataFormatada = formatToSQLDateString(data.createdAt);
            const response = await NotificationService.create({
                createdAt: dataFormatada,
                ...data
            });
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            if(response && response.data && response.data.item) {
                setTimeout(() => {
                    router.push({path: `/form_notification/${response.data.item.id}`});
                }, 3000);
            }
            commit('SET_SHOW_MODAL_CONFIRMATION', false)
            commit('SET_SHOW_MODAL_NOTIFICATION', false)
            commit('SET_LOADING_NOTIFICATIONS', false)
        } catch (error) {
            commit('SET_LOADING_NOTIFICATIONS', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async updadeNotification({commit}, data){
        try{
            commit('SET_LOADING_NOTIFICATIONS', true)
            const response = await NotificationService.update(data);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            commit('SET_LOADING_NOTIFICATIONS', false)
        } catch (error) {
            commit('SET_LOADING_NOTIFICATIONS', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async resendNotificationUserChannel({commit}, data){
        try{
            commit('SET_LOADING_NOTIFICATIONS', true)
            const response = await NotificationService.resend_NotificationUserChannel(data);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            commit('SET_LOADING_NOTIFICATIONS', false)
        } catch (error) {
            commit('SET_LOADING_NOTIFICATIONS', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    }
}

async function formatarData(data) {
    const dataObj = new Date(data);
    const ano = dataObj.getUTCFullYear();
    const mes = (dataObj.getUTCMonth() + 1).toString().padStart(2, '0');
    const dia = dataObj.getUTCDate().toString().padStart(2, '0');
    const hora = dataObj.getUTCHours().toString().padStart(2, '0');
    const minuto = dataObj.getUTCMinutes().toString().padStart(2, '0');

    return `${ano}-${mes}-${dia} ${hora}:${minuto}`;
}

function formatToSQLDateString(dateString) {
    const date = new Date(dateString);
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const hh = String(date.getHours()).padStart(2, '0');
    const mi = String(date.getMinutes()).padStart(2, '0');
    const ss = String(date.getSeconds()).padStart(2, '0');
  
    return `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`;
}

const getters = {
    getNotification: state => state.notification,
    getNotifications: state => state.notifications,
    getNotificationsUser: state => state.notifications_user,
    getLoadingNotification: state => state.loadingNotification,
    getShowModalNewNotification: state => state.show_modal_new_notification
}

export default {
    state,
    getters,
    mutations,
    actions
};